import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { LiveCasinoFilterButtonsDefaultBox } from "./live-casino-filter-buttons.default.box";
import { LiveCasinoFilterButtonsCasino777Box } from "./live-casino-filter-buttons.casino777.box";

export const LiveCasinoFilterButtonsBox = styledByTheme(LiveCasinoFilterButtonsDefaultBox).forCasino777(LiveCasinoFilterButtonsCasino777Box).apply();